import Navbar from "../modules/common/menus/navbar/Navbar";
import { AppShellLayout } from "./AppShellLayout";

const MasterLayout = () => {
  return <AppShellLayout nav={<Navbar />} />;
};

export { MasterLayout };
